import { render, staticRenderFns } from "./ChatSettings.vue?vue&type=template&id=1d60bccf&scoped=true"
import script from "./ChatSettings.vue?vue&type=script&lang=js"
export * from "./ChatSettings.vue?vue&type=script&lang=js"
import style0 from "./ChatSettings.vue?vue&type=style&index=0&id=1d60bccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60bccf",
  null
  
)

export default component.exports